import SweetScroll from '@/helpers/sweet_scroll';
import { toLandingLeadForm } from '@/articles/landing_lead_form';

pageLoad('pages_dostavka', () => {
  $('article.slide-3 .submit').on('click', toLandingLeadForm);
});
